<template>
  <div
    v-if="isShown"
    class="help-text-wrapper rounded-lg pa-2"
  >
    <span class="help-text-wrapper__text ml-1">
      Looking for <strong>landlords insurance</strong>? We’ve a section more suited to this type of cover,
    </span>
    <a
      :href="existingLandlordsLink"
      target="_blank"
      rel="nofollow"
      class="help-text-wrapper__link mr-2 text-decoration-underline"
    >
      <span>click here to get quotes</span>
    </a>
  </div>
</template>

<script>
import {
  inject,
} from '@vue/composition-api';

export default {
  name: 'landlords-suggestion-help-text',
  inject: [
    'config',
    'constants',
  ],
  computed: {
    isShown () {
      const allowedPartners = [
        ...this.constants.PARTNERS.CompareNI,
        ...this.constants.PARTNERS.QuoteZone,
      ];
      return this.isBannerEnabled && allowedPartners.includes(this.config.partner);
    },
    existingLandlordsLink () {
      return this.constants.PARTNERS.CompareNI.includes(this.config.partner)
        ? this.constants.LANDLORDS_LINK.CNI
        : this.constants.LANDLORDS_LINK.QZ;
    },
  },
  setup () {
    const { isBannerEnabled } = inject('abTastyControllerUI');

    return {
      isBannerEnabled,
    };
  },
};
</script>

<style lang="scss" scoped>
.help-text-wrapper {
  border: 1px solid $clr-black;
  background: linear-gradient(180deg, $clr-seopa-light-yellow, $clr-seopa-yellow);

  .help-text-wrapper__link,
  .help-text-wrapper__text {
    vertical-align: middle;
  }

  .help-text-wrapper__link {
    color: inherit;
  }
}
</style>
